var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiverbedcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 16,
    viewBox: "0 0 73 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_84)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_163_84",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 71,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.4281 10.69C68.4281 12.83 67.0375 13.34 65.9471 13.34C64.8567 13.34 63.4661 12.82 63.4661 10.69C63.4661 8.56 64.8567 8.04 65.9471 8.04C67.0375 8.04 68.4281 8.55 68.4281 10.69ZM70.3989 10.69V0.3C70.3989 0.1 70.2989 0 70.0988 0H68.7382C68.5482 0 68.4381 0.1 68.4381 0.3V7.21C67.8779 6.48 66.6874 6.16 65.9571 6.16C63.4461 6.16 61.5153 7.72 61.5153 10.69C61.5153 13.44 63.4661 15.22 65.9571 15.22C68.4481 15.22 70.3989 13.66 70.3989 10.69ZM55.0826 8.04C54.2023 8.04 53.1318 8.38 52.7517 9.62H57.4036C57.0234 8.37 55.953 8.04 55.0726 8.04M59.2043 11.05H52.5916C52.7617 12.89 54.0422 13.34 55.0726 13.34C55.6429 13.34 56.3031 13.21 56.8033 12.72C56.9634 12.62 57.1235 12.55 57.2935 12.63L58.5541 13.19C58.7141 13.25 58.7642 13.42 58.6541 13.58C57.8638 14.67 56.6033 15.23 55.0526 15.23C52.5416 15.23 50.6108 13.67 50.6108 10.7C50.6108 7.73 52.5616 6.17 55.0526 6.17C57.5437 6.17 59.4945 7.73 59.4945 10.7V10.76C59.5045 10.93 59.3644 11.06 59.1943 11.06M46.6792 10.7C46.6792 12.78 45.2886 13.35 44.1982 13.35C43.1077 13.35 41.7171 12.83 41.7171 10.7C41.7171 8.57 43.1077 8.05 44.1982 8.05C45.2886 8.05 46.6792 8.56 46.6792 10.7ZM48.65 10.7C48.65 7.73 46.6992 6.17 44.2082 6.17C43.4779 6.17 42.2874 6.49 41.7272 7.22V0.3C41.7472 0.1 41.6471 0 41.447 0H40.0865C39.8964 0 39.7864 0.1 39.7864 0.3V10.69C39.7864 13.66 41.7372 15.22 44.2282 15.22C46.7192 15.22 48.67 13.32 48.67 10.69M37.5454 7.98C37.5054 8.19 37.4554 8.27 37.2053 8.21C36.8451 8.13 36.505 8.11 36.1549 8.11C35.2145 8.11 34.3641 8.45 34.3641 9.82V14.68C34.3641 14.87 34.2641 14.98 34.064 14.98H32.7034C32.5134 14.98 32.4033 14.88 32.4033 14.68V9.82C32.4033 7.17 33.984 6.21 35.9548 6.21C36.475 6.21 37.0052 6.27 37.5354 6.42C37.7455 6.47 37.8255 6.6 37.7655 6.81L37.5454 7.98ZM28.2716 9.63H23.6097C23.9999 8.4 25.0603 8.05 25.9407 8.05C26.821 8.05 27.8915 8.39 28.2816 9.63M30.4025 10.76V10.7C30.4025 7.73 28.4517 6.17 25.9607 6.17C23.4696 6.17 21.5188 7.73 21.5188 10.7C21.5188 13.67 23.4696 15.23 25.9607 15.23C27.5113 15.23 28.7718 14.67 29.5621 13.58C29.6622 13.42 29.6022 13.26 29.4621 13.19L28.2016 12.63C28.0315 12.54 27.8614 12.6 27.7114 12.72C27.2212 13.21 26.5509 13.34 25.9807 13.34C24.9503 13.34 23.6697 12.89 23.4997 11.05H30.1124C30.2524 11.05 30.4125 10.92 30.4125 10.75M17.077 14.69C17.017 14.88 16.8669 14.96 16.6769 14.96H15.1262C14.9361 14.96 14.7861 14.87 14.696 14.69L11.2946 6.69C11.2346 6.53 11.3347 6.42 11.4847 6.42H13.0354C13.2254 6.42 13.3755 6.51 13.4355 6.69L15.8865 12.59L18.3375 6.69C18.3976 6.5 18.5476 6.42 18.7377 6.42H20.2883C20.4484 6.42 20.5184 6.55 20.4584 6.69L17.067 14.69H17.077ZM9.32383 6.71C9.32383 6.52 9.22379 6.41 9.02371 6.41H7.66315C7.47307 6.41 7.36303 6.51 7.36303 6.71V14.66C7.36303 14.85 7.46307 14.96 7.66315 14.96H9.02371C9.21379 14.96 9.32383 14.86 9.32383 14.66V6.72V6.71ZM8.33342 1.81C8.9937 1.81 9.53392 2.34 9.53392 3.01C9.53392 3.68 9.0037 4.21 8.33342 4.21C7.66315 4.21 7.13293 3.68 7.13293 3.01C7.13293 2.34 7.66315 1.81 8.33342 1.81ZM5.3622 6.78C5.40222 6.57 5.33219 6.46 5.13211 6.39C4.60189 6.22 4.06167 6.18 3.55146 6.18C1.59065 6.18 0 7.14 0 9.79V14.65C0 14.84 0.100041 14.95 0.300123 14.95H1.63067C1.82075 14.95 1.93079 14.85 1.93079 14.65V9.8C1.93079 8.44 2.79115 8.09 3.72153 8.09C4.06167 8.09 4.41181 8.12 4.77196 8.19C5.02206 8.24 5.08209 8.15 5.1121 7.96L5.33219 6.78H5.3622Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_163_84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.159 8.52007L55.0127 71.6401L-27.4712 -10.8199L35.6648 -73.9399L118.159 8.52007Z",
    fill: "url(#paint0_linear_163_84)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1393 0C72.6193 0 72.9993 0.38 72.9993 0.86C72.9993 1.34 72.6193 1.72 72.1393 1.72C71.6593 1.72 71.2793 1.34 71.2793 0.86C71.2993 0.38 71.6793 0 72.1393 0ZM72.1393 1.55C72.5293 1.55 72.8293 1.25 72.8293 0.86C72.8293 0.47 72.5193 0.17 72.1393 0.17C71.7593 0.17 71.4493 0.48 71.4493 0.86C71.4493 1.24 71.7593 1.55 72.1393 1.55ZM71.8193 0.41C71.8193 0.41 71.8293 0.37 71.8593 0.37H72.1993C72.3893 0.37 72.5393 0.47 72.5393 0.72C72.5393 0.89 72.4593 0.99 72.3493 1.03L72.5393 1.3C72.5393 1.3 72.5393 1.33 72.5293 1.33H72.3893C72.3893 1.33 72.3393 1.32 72.3293 1.3L72.1593 1.05H72.0193V1.28C72.0193 1.28 72.0093 1.32 71.9793 1.32H71.8793C71.8793 1.32 71.8393 1.31 71.8393 1.28V0.4L71.8193 0.41ZM72.1993 0.89C72.2993 0.89 72.3593 0.84 72.3593 0.72C72.3593 0.6 72.3093 0.55 72.1993 0.55H72.0193V0.89H72.1993Z",
    fill: "#F5875B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_163_84",
    x1: 13.9458,
    y1: 31.3501,
    x2: 77.3549,
    y2: -34.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#5053A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#5753A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6954A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#7A55A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8454A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9C51A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#9F509F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D73D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E03D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EE3E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F26962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F3755F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F4A156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FACB41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD936"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 15.22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiverbedcard);
export default __webpack_public_path__ + "static/media/riverbedcard.e695ac47546f42bd0cd3401776e6e50b.svg";
export { ForwardRef as ReactComponent };